export interface OfferItem {
    id: number
    urlFriendlyName: string
    name: TranslatedString
    description: TranslatedString
    price: {
        value: string
        type: PriceType
    }
    status: Status
    params: Parameter[]
    miniatureUrl?: string
    pictures: Picture[]
}

export interface TranslatedString {
    pl: string
    en: string
}

export enum PriceType {
    INCLUDING_VAT = 'INCLUDING_VAT',
    EXCLUDING_VAT = 'EXCLUDING_VAT',
    FREE_OF_VAT = 'FREE_OF_VAT'
}

export enum Status {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    DELETED = 'DELETED'
}

export interface Parameter {
    id: string
    name: TranslatedString
    value: string
}

export interface Picture {
    id: string
    url: string
    miniatureUrl?: string
    main: boolean
}
